import { Image } from '@cian/ui-kit';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as React from 'react';

import { getPromoIcon } from './PromoIcons/getPromoIcon';
import styles from './styles.css';
import { getPromoClassName } from './utils/getPromoClassName';
import { EType } from '../../../types/villagePromotions';
interface IPromoItemProps {
  name: string;
  type: EType;
  onClick(): void;
  subtitle?: string | null;
  icon?: string | null;
}

export function PromoItem(props: IPromoItemProps) {
  const { type, name, onClick, icon, subtitle } = props;
  const promoClassName = icon ? undefined : getPromoClassName(type);

  return (
    <div className={classNames(styles['container'], promoClassName)} onClick={onClick}>
      <div className={styles['icon']}>{icon ? <Image src={icon} title="Иконка акции" /> : getPromoIcon(type)}</div>
      <div>
        <div className={styles['title']}>
          <ArticleHeading4 fontWeight="bold">{name}</ArticleHeading4>
        </div>
        {subtitle && (
          <div className={styles['subtitle']}>
            <ArticleParagraph2 color="gray60_100">{subtitle}</ArticleParagraph2>
          </div>
        )}
      </div>
    </div>
  );
}
